module.exports = __webpack_public_path__ + "static/waves-0499360fa40039f51ba1363571259d75.png";